import styled from 'styled-components';
import { StyledAdminListRow } from '../../AdminListHeaderCell/styles/StyledAdminListRow';
import { StyledButton } from 'components/shared/Button/styles';

export const StyledAdminPoolConfigsListRow = styled.div`
  ${StyledAdminListRow}

  ${StyledButton} {
    @media (min-width: 768px) and (max-width: 1440px) {
      padding: 0.8rem 1.8rem;
      font-size: 1.2rem;
    }

    @media (min-width: 1440px) and (max-width: 2118px) {
      padding: 0.8rem 2.6rem;
      font-size: 1.4rem;
    }

    @media screen and (min-width: 2118px) {
      padding: 0.8rem 2.6rem;
      font-size: 1.4rem;
    }
  }

  input {
    background-color: ${(props) => props.theme.bg4};
    border: none;
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.text1 : props.theme.text1)};
    font-size: 1.4rem;
    font-weight: 500;
  }

  input:focus {
    outline: 0;
  }

  .admin-list-cell-container {
    &.id,
    &.port,
    &.algorithm,
    &.actions {
      flex-basis: initial;
      flex-grow: 0;
    }

    &.id {
      width: 6.4rem;
    }

    &.actions {
      width: 10.8rem;

      @media (min-width: 768px) and (max-width: 1440px) {
        width: 8.8rem;
      }
    }

    &.port,
    &.algorithm {
      width: 14.4rem;
    }
  }

  @media screen and (max-width: 1100px) {
    width: 110rem;
  }
`;
